module.exports = __webpack_public_path__ + "img/zngc.49e2be67.jpg";